module.exports = __webpack_public_path__ + "static/media/Steve Jobs_1_t.fc2c34a0.jpg";